
import { Component, OnInit, Input, EventEmitter, Output, HostListener, ViewChild, AfterViewInit, Renderer2, ElementRef } from '@angular/core';
import { LookupsService, Paging, SearchBaseComponent, SearchCriteria, SortingDirection, SystemConfigurationService } from '@linkdev/shared-library';
import { ServiceListViewModel } from './models/serviceListViewModel';
import { TranslateService } from '@ngx-translate/core';
import { DocumentsService } from '@linkdev/document-manage-library';
import { ServiceManageService, ServiceManagementRoutes } from '@linkdev/service-management-library';
import { OffcanvasService } from '../shared/services/offcanvas.service';
import { AppConfigService } from '../core/config/app-config.service';

@Component({
  selector: 'service-list',
  templateUrl: './service-list.component.html',
})
export class ServiceListComponent extends SearchBaseComponent implements OnInit, AfterViewInit {
  @ViewChild('offcanvasButtonTop') offcanvasButtonTop: ElementRef;
  @ViewChild('closeButtonTop') closeButtonTop: ElementRef;
  @ViewChild('offcanvasDivTop') offcanvasDivTop: ElementRef;

  @ViewChild('offcanvasButtonSort') offcanvasButtonSort: ElementRef;
  @ViewChild('closeButtonSort') closeButtonSort: ElementRef;
  @ViewChild('offcanvasDivSort') offcanvasDivSort: ElementRef;

  ngAfterViewInit() {
    const buttonElements = [
      this.offcanvasButtonTop.nativeElement,
      this.offcanvasButtonSort.nativeElement,
      this.closeButtonTop.nativeElement,
      this.closeButtonSort.nativeElement
    ];

    this.offcanvasService.renderer.listen(this.offcanvasButtonTop.nativeElement, 'click', () => {
      this.offcanvasService.debounce(() => this.offcanvasService.toggleVisibility(this.offcanvasDivTop.nativeElement, buttonElements), 100);
    });

    this.offcanvasService.renderer.listen(this.offcanvasButtonSort.nativeElement, 'click', () => {
      this.offcanvasService.debounce(() => this.offcanvasService.toggleVisibility(this.offcanvasDivSort.nativeElement, buttonElements), 100);
    });

    this.offcanvasService.renderer.listen(this.closeButtonTop.nativeElement, 'click', () => {
      this.offcanvasService.hideOffcanvas(this.offcanvasDivTop.nativeElement);
    });

    this.offcanvasService.renderer.listen(this.closeButtonSort.nativeElement, 'click', () => {
      this.offcanvasService.hideOffcanvas(this.offcanvasDivSort.nativeElement);
    });
  }

  apply() {
    this.submit();
    this.offcanvasClearFilter();
    this.offcanvasService.hideOffcanvas(this.offcanvasDivTop.nativeElement);
  }

  onClearFilters() {
    this.offcanvasClearFilter();
    this.model.searchKeyword = '';
    this.searchCriteria.filterCriteria = [];
    this.loadPage();
    this.offcanvasService.hideOffcanvas(this.offcanvasDivTop.nativeElement);
  }

  submitSort() {
    this.submit();
    this.offcanvasClearSort();
    this.offcanvasService.hideOffcanvas(this.offcanvasDivSort.nativeElement);
  }

  clearSort() {
    this.offcanvasClearSort();
    this.loadPage();
    this.offcanvasService.hideOffcanvas(this.offcanvasDivSort.nativeElement);
  }
  stripHtml(html: string): string {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || '';
  }
  trackByIndex(index: number): number {
    return index;
  }
   



  @Output() componentLoaded = new EventEmitter();
  @Input() isHomepage: boolean = false;
  @Input() baseURL: string;
  @Input() pageSize = 9;
  baseuRL: string;
  currentURL: string;


  serviceManagementRoutesBaseRoute: string = ServiceManagementRoutes.baseRoute;
  serviceDetailsRoute: string = `#/${this.serviceManagementRoutesBaseRoute}/${ServiceManagementRoutes.serviceDetailsRoute}`;
  serviceCardsRoute: string = `#/${this.serviceManagementRoutesBaseRoute}/${ServiceManagementRoutes.serviceCardsRoute}`;

  totalCount: any;
  userTypeList: any[] = [];
  sortDirList: any[] = [];
  serviceList: Array<ServiceListViewModel> = [];
  translationData: any = {};
  model: { serviceCategories: any[], userType: any[], searchKeyword: string, sortDir: string, sortDirMobile: string } = { serviceCategories: [], userType: [], searchKeyword: '', sortDir: '', sortDirMobile: '' };
  isSearchOpen: boolean = false;
  isFiltersOpen: boolean = false;
  firstSearchLength: number = null;
  page: number;
  start: number = 0;
  isMobile: boolean = false;
  ServiceCategoryList: any[] = [];
  showServicesimage: boolean = false;

  profileTypesSearchKey: string = 'ProfileTypesIds';
  CategoriesSearchKey: string = 'CategoriesIds';
  keywordSearchKey: string = 'ServiceName';
  serviceOrderKey: string = 'ServiceOrder';
  idKey: string = 'Id';
  currentSelectedCategoriesCommaSpereated: string = null;
  currentSelectedUserTypesCommaSpereated: string = null;

  appliedSearchCriteria: any;
  firstPageLoaded: boolean = false;


  constructor(
    public _service: ServiceManageService,
    private _translate: TranslateService,
    private _lookupService: LookupsService,
    private _systemConfigService: SystemConfigurationService,
    public documentsService: DocumentsService,
    private renderer: Renderer2,
    private offcanvasService: OffcanvasService
  ) {
    super();
  }

  extractBaseURL(): void {
    const indexOfHash = this.currentURL.indexOf('/#');
    if (indexOfHash !== -1) {
      this.baseuRL = this.currentURL.substring(0, indexOfHash);
    } else {
      this.baseuRL = this.currentURL;
    }
  }
  ngOnInit(): void {
    this.currentURL = window.location.href;
    this.extractBaseURL();
    this.checkIsMobile();

    this._translate.get("serviceManagement").subscribe((data) => {
      this.translationData = data;
      document.title = (this.translationData.serviceCatalog || "Service Catalog") + (this.translationData.portalNameForDocumentTitle || "");

      this.sortDirList = [{ displayName: (this.translationData?.aZ || "A-Z"), uniqueKey: "asc" }, { displayName: (this.translationData?.zA || "Z-A"), uniqueKey: "desc" }];

      var allOption = { displayName: this.translationData.all, id: null };

      this._service.getProfileTypes().subscribe(res => {
        res.unshift(allOption);
        this.userTypeList = res.map(item => ({ ...item, selected: false }));
        this.userTypeList = this.userTypeList.filter(function (item) {
          return item.id !== 1003
        });
      });
    });

    this._lookupService.getLookups(["ServiceCategory"]).subscribe(res => {
      this.ServiceCategoryList = res.find(lookup => lookup.lookupName == "ServiceCategory").lookupItems.map(item => ({ ...item, selected: false }));
    });

    this._systemConfigService.getSystemConfigurationByKeys(['showImageInServiceCatalogue']).subscribe(config => {
      this.showServicesimage = config[0].value;
    });

    
    this.prepareFirstPageFilterCriteria();
    this._service.getServicesPage(this.appliedSearchCriteria).subscribe(
      (res) => {
        this.firstPageLoaded = true;
        this.onGetServicePageSuccess(res);
      }, () => {
        this.serviceList = [];
      }
    );
  }

  submit() {
    this.start = 0;
    this.loadPage();
    this.isSearchOpen = false;
  }


  offcanvasClearFilter() {
    this.userTypeList.forEach(item => item.selected = false);
    this.model.userType = [];
    this.currentSelectedUserTypesCommaSpereated = null;
    this.ServiceCategoryList.forEach(item => item.selected = false);
    this.model.serviceCategories = [];
    this.currentSelectedCategoriesCommaSpereated = null;
  }

  pageChange($event) {
    this.page = $event.page;
    this.start = $event.first;
    this.loadPage(this.page);
  }


  offcanvasClearSort() {
    this.model.sortDir = '';
    this.model.sortDirMobile = '';
  }

  loadPage(page = 0) {
    if (!this.firstPageLoaded)
      return;

    let userTypeIds = this.model.userType.map(item => item.id);
    let sortDirection = null;

    if (this.model.sortDirMobile) {
      sortDirection = this.model.sortDirMobile == "asc" ? SortingDirection.ASC : SortingDirection.DESC;
    }
    else if (this.model.sortDir) {
      sortDirection = this.model.sortDir == "asc" ? SortingDirection.ASC : SortingDirection.DESC;
    }

    if (userTypeIds.length > 0) {
      this.addFilterCriteria(this.profileTypesSearchKey, this.FilterTypeEnum.Equals, userTypeIds.toString());
    } else if (this.searchCriteria.filterCriteria && this.searchCriteria.filterCriteria.some(filter => filter.filterName == this.profileTypesSearchKey)) {
      this.searchCriteria.filterCriteria = this.searchCriteria.filterCriteria.filter(f => f.filterName != this.profileTypesSearchKey);
    }

    if (this.currentSelectedCategoriesCommaSpereated) {
      this.addFilterCriteria(this.CategoriesSearchKey, this.FilterTypeEnum.Equals, this.currentSelectedCategoriesCommaSpereated);
    } else if (this.searchCriteria.filterCriteria && this.searchCriteria.filterCriteria.some(filter => filter.filterName == this.CategoriesSearchKey)) {
      this.searchCriteria.filterCriteria = this.searchCriteria.filterCriteria.filter(f => f.filterName != this.CategoriesSearchKey);
    }

    if (this.model.searchKeyword) {
      let keywordPhrase = this.model.searchKeyword;
      this.addFilterCriteria(this.keywordSearchKey, this.FilterTypeEnum.Like, keywordPhrase);
    } else if (this.searchCriteria.filterCriteria && this.searchCriteria.filterCriteria.some(filter => filter.filterName == this.keywordSearchKey)) {
      this.searchCriteria.filterCriteria = this.searchCriteria.filterCriteria.filter(f => f.filterName != this.keywordSearchKey);
    }

    this.addBlackListServicesIdsFilter();

    this.addPageCriteria(page, this.pageSize);

    this.addSortCriteria(sortDirection == null ? this.serviceOrderKey : this.keywordSearchKey, sortDirection == null ? SortingDirection.ASC : sortDirection);

    if (JSON.stringify(this.appliedSearchCriteria) == JSON.stringify(this.searchCriteria)) {
      return;
    }
    this.appliedSearchCriteria = JSON.parse(JSON.stringify(this.searchCriteria));

    this._service.getServicesPage(this.searchCriteria)
      .subscribe(this.onGetServicePageSuccess);
  }

  onGetServicePageSuccess = (res) => {
    res.collection.forEach(service => {
      this.getImgPath(service?.image);
    });

    res.collection = res.collection.filter(obj => obj.id !== 5);
    this.serviceList = [...res.collection] as ServiceListViewModel[];
    this.totalCount = res.totalCount;

    if (this.firstSearchLength === null) {
      this.firstSearchLength = this.serviceList.length;
      this.componentLoaded.emit(this.serviceList);
    }
  }

  sort() {
    this.model.sortDirMobile = null;
    this.submit();
  }

  onClearFiltersClick(mobileForm) {
    mobileForm.reset();
    this.submit();
  }

  toggleFilters() {
    this.isFiltersOpen = !this.isFiltersOpen;
  }

  toggleSearch() {
    this.isSearchOpen = !this.isSearchOpen;
  }

  checkIsMobile() {
    if (window.innerWidth <= 991) {
      this.isMobile = true;
    }
  }

  getServiceCategoryPerModule(categoryIds: string): string {
    let categories = '';
    if (categoryIds) {
      let idsSplitted = categoryIds.split(',');

      idsSplitted.forEach(element => {
        var el = element.replace(/^[ ]+|[ ]+$/g, '')
        if (this.ServiceCategoryList) {
          let category = this.ServiceCategoryList.find(c => c.id == el)?.displayName;
          categories += category ? category + ", " : '';
        }
      });

      return categories.substring(0, categories.length - 2);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkIsMobile();
  }

  onMultiSelectValueChange(event, submit: boolean) {
    // Update model.serviceCategories based on selected items
    this.model.serviceCategories = this.ServiceCategoryList
      .filter(item => item.selected)
      .map(item => item.id);

    // Update the currentSelectedCategoriesCommaSpereated string
    this.currentSelectedCategoriesCommaSpereated = this.model.serviceCategories.length
      ? this.model.serviceCategories.toString()
      : null;
    if (submit) {
      this.submit();
    }
  }
  onMultiSelectValueChangeResponsive(event, submit: boolean) {
    // Update model.serviceCategories based on selected items
    this.model.serviceCategories = this.ServiceCategoryList
      .filter(item => item.selected)
      .map(item => item.id);

    // Update the currentSelectedCategoriesCommaSpereated string
    this.currentSelectedCategoriesCommaSpereated = this.model.serviceCategories.length
      ? this.model.serviceCategories.toString()
      : null;

  }

  onUserTypeChange(event: any, item: any) {
    item.selected = event.target.checked;
    this.model.userType = this.userTypeList
      .filter(type => type.selected)
      .map(type => ({ id: type.id, displayName: type.displayName }));

    // Update the currentSelectedUserTypesCommaSpereated string
    this.currentSelectedUserTypesCommaSpereated = this.model.userType.length
      ? this.model.userType.map(type => type.id).toString()
      : null;

    this.submit();
  }
  onUserTypeResponsive(event: any, item: any) {
    item.selected = event.target.checked;
    this.model.userType = this.userTypeList
      .filter(type => type.selected)
      .map(type => ({ id: type.id, displayName: type.displayName }));

    // Update the currentSelectedUserTypesCommaSpereated string
    this.currentSelectedUserTypesCommaSpereated = this.model.userType.length
      ? this.model.userType.map(type => type.id).toString()
      : null;
  }

  defaultAvatar = "../../assets/images/service-avatar.webp";
  imagesDic: any = {};
  getImgPath(img) {
    if (this.imagesDic[img] || this.imagesDic[img + 'requesting']) {
      return;
    }

    if (img && !this.imagesDic[img]) {
      this.imagesDic[img + 'requesting'] = true;
      this._service.getDocumentContent(img)
        .subscribe(
          event => {
            this.imagesDic[img + 'requesting'] = false;
            this.imagesDic[img] = this.documentsService.getBlobURL(event.body);
          },
          () => {
            this.imagesDic[img + 'requesting'] = false;
            this.imagesDic[img] = img;
          }
        );
    }
  }

  getImageSrc(img) {
    //return this.imagesDic[img] || this.defaultAvatar;
    return this.imagesDic[img] || null;
  }

  private prepareFirstPageFilterCriteria() {
    this.addPageCriteria(0, this.pageSize);
    this.addSortCriteria(this.serviceOrderKey, SortingDirection.ASC);
    this.addBlackListServicesIdsFilter();
    this.appliedSearchCriteria = JSON.parse(JSON.stringify(this.searchCriteria));
  }

  private addBlackListServicesIdsFilter() {
    if (!this.searchCriteria.filterCriteria?.some(c => c.filterName == this.idKey)){
      let blackListServicesIds = AppConfigService.settings.blackListServicesIds;
      this.addNestedFilterValuesCriteria(this.idKey, this.FilterTypeEnum.NotEquals, blackListServicesIds, this.LogicalOperatorEnum.And);
    }
  }
}
